"use strict";

exports.__esModule = true;
exports.stateDetails = void 0;
var stateDetails = exports.stateDetails = [{
  key: "producing",
  name: "Producing",
  color: "#6FC376",
  getHSLColor: function getHSLColor(_ref) {
    var _ref$saturation = _ref.saturation,
      saturation = _ref$saturation === void 0 ? 41 : _ref$saturation,
      _ref$lightness = _ref.lightness,
      lightness = _ref$lightness === void 0 ? 60 : _ref$lightness;
    return "hsl(125, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "downtime.unplanned",
  name: "Unplanned Downtime",
  color: "#F6928F",
  getHSLColor: function getHSLColor(_ref2) {
    var _ref2$saturation = _ref2.saturation,
      saturation = _ref2$saturation === void 0 ? 85 : _ref2$saturation,
      _ref2$lightness = _ref2.lightness,
      lightness = _ref2$lightness === void 0 ? 76 : _ref2$lightness;
    return "hsl(2, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "downtime.planned",
  name: "Planned Downtime",
  color: "#FBBC6D",
  getHSLColor: function getHSLColor(_ref3) {
    var _ref3$saturation = _ref3.saturation,
      saturation = _ref3$saturation === void 0 ? 95 : _ref3$saturation,
      _ref3$lightness = _ref3.lightness,
      lightness = _ref3$lightness === void 0 ? 71 : _ref3$lightness;
    return "hsl(33, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "standby",
  name: "Standby",
  color: "#B1DAAE",
  getHSLColor: function getHSLColor(_ref4) {
    var _ref4$saturation = _ref4.saturation,
      saturation = _ref4$saturation === void 0 ? 37 : _ref4$saturation,
      _ref4$lightness = _ref4.lightness,
      lightness = _ref4$lightness === void 0 ? 77 : _ref4$lightness;
    return "hsl(116, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "setup",
  name: "Setup",
  color: "#CDA5CD",
  getHSLColor: function getHSLColor(_ref5) {
    var _ref5$saturation = _ref5.saturation,
      saturation = _ref5$saturation === void 0 ? 29 : _ref5$saturation,
      _ref5$lightness = _ref5.lightness,
      lightness = _ref5$lightness === void 0 ? 73 : _ref5$lightness;
    return "hsl(300, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "shutdown",
  name: "Shutdown",
  color: "#5DA5DA",
  getHSLColor: function getHSLColor(_ref6) {
    var _ref6$saturation = _ref6.saturation,
      saturation = _ref6$saturation === void 0 ? 63 : _ref6$saturation,
      _ref6$lightness = _ref6.lightness,
      lightness = _ref6$lightness === void 0 ? 61 : _ref6$lightness;
    return "hsl(205, " + saturation + "%, " + lightness + "%)";
  }
}, {
  key: "data-unavailable",
  name: "Data Unavailable",
  color: "#C1C1C1",
  getHSLColor: function getHSLColor(_ref7) {
    var _ref7$saturation = _ref7.saturation,
      saturation = _ref7$saturation === void 0 ? 0 : _ref7$saturation,
      _ref7$lightness = _ref7.lightness,
      lightness = _ref7$lightness === void 0 ? 76 : _ref7$lightness;
    return "hsl(0, " + saturation + "%, " + lightness + "%)";
  }
}];